// Picker "Nền chữ (kiểu Facebook)" cho bài text-only: dãy swatch (ô đầu =
// "không nền") + mini preview khi có preset được chọn. Chỉ render khi cha
// xác định điều kiện (không ảnh + nội dung ngắn) đã thoả — component này
// không tự kiểm tra điều kiện, chỉ lo UI chọn màu.
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import COMMUNITY_BG_PRESETS, { communityBgGradient } from "./community-bg-presets";
import { renderCommunityRichText } from "./community-rich-text";

const PRESET_KEYS = Object.keys(COMMUNITY_BG_PRESETS);

const swatchRingClass = (selected) =>
    `w-8 h-8 rounded-lg cursor-pointer transition-shadow ${
        selected ? "ring-2 ring-blue-500 ring-offset-1" : "hover:ring-2 hover:ring-line-strong hover:ring-offset-1"
    }`;

export default function CommunityBgPresetPicker({ value, onChange, previewText }) {
    return (
        <div className="mb-4">
            <div className="mb-1.5 text-sm font-medium text-content-2">Nền chữ (kiểu Facebook)</div>
            <div className="flex flex-wrap gap-2">
                <button
                    type="button"
                    aria-label="Không dùng nền"
                    onClick={() => onChange(null)}
                    className={`${swatchRingClass(!value)} bg-surface border border-line-strong flex items-center justify-center text-content-3`}
                >
                    <FontAwesomeIcon icon={faBan} />
                </button>
                {PRESET_KEYS.map((key) => (
                    <button
                        type="button"
                        key={key}
                        aria-label={`Nền ${key}`}
                        onClick={() => onChange(key)}
                        className={swatchRingClass(value === key)}
                        style={{ background: communityBgGradient(key) }}
                    />
                ))}
            </div>

            {value && (
                <div
                    className="mt-3 rounded-lg min-h-[100px] flex items-center justify-center px-4 py-5"
                    style={{ background: communityBgGradient(value) }}
                >
                    <p className="text-white font-bold text-center leading-snug whitespace-pre-wrap break-words">
                        {previewText?.trim() ? renderCommunityRichText(previewText, true) : "Nội dung bài đăng…"}
                    </p>
                </div>
            )}
        </div>
    );
}
